import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const PauseIcon = React.memo(
  ({ fill = variables['colors-mc-primary'], width = '30', viewBox = '0 0 30 30' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(width)}
      viewBox={viewBox}
    >
      <circle id='Ellipse_168' data-name='Ellipse 168' cx='15' cy='15' r='15' fill={fill} />
      <g id='Group_3393' data-name='Group 3393' transform='translate(11.25 9)'>
        <rect
          id='Rectangle_1285'
          data-name='Rectangle 1285'
          width='2.25'
          height='12'
          rx='1'
          fill='#fff'
        />
        <rect
          id='Rectangle_1286'
          data-name='Rectangle 1286'
          width='2.25'
          height='12'
          rx='1'
          transform='translate(5.25)'
          fill='#fff'
        />
      </g>
    </svg>
  )
);
PauseIcon.displayName = 'PauseIcon';

export default PauseIcon;
